/// <reference path="../../../../Scripts/typings/q/Q.d.ts" />
/// <reference path="../../../../Scripts/typings/durandal/durandal.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/viewmodels/index',["require", "exports", "models/breeze", "common/viewmodelbase", "common/parts", "common/commands", "areas/navigationmanager/services/navigationrepository", "areas/navigationmanager/services/mappings", "areas/navigationmanager/services/iconlist", "areas/navigationmanager/commands/createnavigationnodecommand", "areas/navigationmanager/commands/removenavigationnodecommand", "areas/navigationmanager/commands/movenavigationnodecommand", "areas/navigationmanager/commands/savenavigationmodelcommand", "areas/navigationmanager/commands/creategroupcommand", "areas/navigationmanager/commands/removegroupcommand", "areas/navigationmanager/parts/loadmodules", "areas/navigationmanager/parts/createnavigationnode", "areas/navigationmanager/parts/removenavigationnode", "areas/navigationmanager/parts/movenavigationnode", "areas/navigationmanager/parts/savenavigationmodel", "areas/navigationmanager/parts/creategroup", "areas/navigationmanager/parts/removegroup"], function (require, exports, Data, ViewModel, Parts, Commanding, Repository, Mapping, IconList, CreateNavigationNodeCommand, RemoveNavigationNodeCommand, MoveNavigationNodeCommand, SaveNavigationModelCommand, CreateGroupCommand, RemoveGroupCommand, LoadModules, CreateNavigationNode, RemoveNavigationNode, MoveNavigationNode, SaveNavigationModel, CreateGroup, RemoveGroup) {
    "use strict";
    var IndexViewModel = (function (_super) {
        __extends(IndexViewModel, _super);
        // #region ctor
        function IndexViewModel() {
            _super.call(this);
            this._navigations = new Repository.NavigationRepository();
            this.navigationItems = [];
            this.shortcuts = [];
            var that = this;
            this.title = $.t("app:modules.navigationManager.headline_title", { ifMissing: "Navigationskonfiguration" });
            ko.track(this, ["currentNavigationModel", "currentNode", "selectedNode", "shortcuts", "navigationItems", "icons", "groups", "selectedGroup", "memberTypeModules"]);
        }
        // #endregion
        // #region overrides
        IndexViewModel.prototype.onActivated = function (context) {
            if (this.controller == null) {
                return Q.when(this.initialize());
            }
            return null;
        };
        // #endregion
        // #region command handling
        IndexViewModel.prototype.onOpenNavigationCommand = function (navigation) {
            this.currentNavigationModel = navigation;
            this.memberTypeModules = this.getModulesForMemberType();
            this.onNavigate(this.currentNavigationModel.model);
        };
        IndexViewModel.prototype.onEditNode = function (symbol) {
            this.selectedNode = symbol;
            this.selectedGroup = null;
        };
        IndexViewModel.prototype.onEditGroup = function (symbol) {
            this.selectedNode = null;
            this.selectedGroup = symbol;
        };
        IndexViewModel.prototype.onNavigate = function (symbol) {
            var _this = this;
            this.currentNode = symbol;
            this.groups = symbol.groups;
            var nodeType = symbol.type;
            var navigationItems = [];
            if (nodeType != "ApplicationLink") {
                this.selectedNode = null;
                this.selectedGroup = null;
                this.shortcuts.removeAll();
                this.navigationItems.removeAll();
                var children = nodeType == "ApplicationLink" ? symbol.parent.children : symbol.children;
                var list = nodeType == "Application" || nodeType == "ApplicationLink" ? this.shortcuts : navigationItems;
                Enumerable.From(children)
                    .ForEach(function (child) {
                    list.push(child);
                });
                // gruppierung
                Enumerable.From(this.groups)
                    .OrderBy(function (x) { return x.index; })
                    .ForEach(function (gr) {
                    var itm = {
                        key: gr.key,
                        list: Enumerable.From(navigationItems).Where(function (_) { return _.groupId == gr.key; }).OrderBy(function (x) { return x.index; }).ToArray(),
                        parentGroup: gr
                    };
                    _this.navigationItems.push(itm);
                });
                // Sort navigation items by group index
                this.navigationItems = Enumerable.From(this.navigationItems).OrderBy(function (x) { return x.parentGroup != null ? x.parentGroup.index : 0; }).ToArray();
            }
        };
        // #endregion
        IndexViewModel.prototype.initialize = function () {
            var _this = this;
            this.icons = IconList.getFullIconList();
            this.controller = new Data.BreezeDataController(this._navigations)
                .configure(function (d) { return _this.mapEntities(d); });
            // processes
            Parts.PartBinder.bind(new LoadModules(), function (symbol) { return _this.modules = symbol; }).process({});
            var createNavigationNode = Parts.PartBinder.bind(new CreateNavigationNode(function () { return _this.currentNode; }), function (symbol) {
                _this.onNavigate(_this.currentNode);
                _this.onEditNode(symbol);
            });
            var removeNavigationNode = Parts.PartBinder.bind(new RemoveNavigationNode(), function (symbol) {
                _this.onNavigate(_this.currentNode);
            });
            var moveNavigationNode = Parts.PartBinder.bind(new MoveNavigationNode(), function (symbol) {
                _this.onNavigate(_this.currentNode);
                _this.onEditNode(symbol);
            });
            var saveNavigationModel = Parts.PartBinder.bind(new SaveNavigationModel(this.taskManager), function (symbol) {
                _this.onNavigate(_this.currentNode);
            });
            var createGroup = Parts.PartBinder.bind(new CreateGroup(function () { return _this.currentNode; }), function (symbol) {
                _this.onNavigate(_this.currentNode);
                _this.onEditGroup(symbol);
            });
            var removeGroup = Parts.PartBinder.bind(new RemoveGroup(function () { return _this.currentNode; }), function (symbol) {
                _this.onNavigate(_this.currentNode);
            });
            // commands
            this.openNavigationModelCommand = new Commanding.DelegateCommand(this.onOpenNavigationCommand, this);
            this.saveNavigationModelCommand = new SaveNavigationModelCommand(saveNavigationModel);
            this.editNodeCommand = new Commanding.DelegateCommand(this.onEditNode, this);
            this.navigateCommand = new Commanding.DelegateCommand(this.onNavigate, this);
            this.createNavigationNodeCommand = new CreateNavigationNodeCommand(createNavigationNode);
            this.removeNavigationNodeCommand = new RemoveNavigationNodeCommand(removeNavigationNode);
            this.moveNavigationNodeCommand = new MoveNavigationNodeCommand(moveNavigationNode);
            this.editGroupCommand = new Commanding.DelegateCommand(this.onEditGroup, this);
            this.createGroupCommand = new CreateGroupCommand(createGroup);
            this.removeGroupCommand = new RemoveGroupCommand(removeGroup);
        };
        IndexViewModel.prototype.mapEntities = function (entities) {
            var items = [];
            for (var i = 0; i < entities.length; i++) {
                var item = entities[i];
                items.push(Mapping.mapNavigationFromDTO(item));
            }
            // result
            return items;
        };
        IndexViewModel.prototype.getModulesForMemberType = function () {
            var _this = this;
            var items = this.modules.filter(function (module) { return module.memberType === _this.currentNavigationModel.memberType; });
            return items;
        };
        return IndexViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new IndexViewModel();
    return instance;
});

